import { getFormFieldValidations, isEmailValid } from '@avalara/bat-apps-shared/lib/form-validation';

export type AviatorCrushLeadFieldName = 'firstName' | 'lastName' | 'email';
export type AviatorCrushLead = Record<AviatorCrushLeadFieldName, string>;

export const AVIATOR_CRUSH_LEAD_FIELD_NAMES: ReadonlyArray<AviatorCrushLeadFieldName> = [
  'firstName',
  'lastName',
  'email',
];

const { firstName: firstNamePattern, lastName: lastNamePattern } = getFormFieldValidations(null);

export const isAviatorCrushLeadFieldValid = (fieldName: AviatorCrushLeadFieldName, value: string): boolean => {
  if (fieldName === 'email') return isEmailValid(value);
  const pattern = fieldName === 'firstName' ? firstNamePattern : lastNamePattern;
  return value.trim().length > 0 && pattern.test(value);
};

// Used to decide whether a lead cookie can drive an automatic signup (all three fields present
// and valid) or only prefill the form (anything missing/invalid falls back to manual entry).
export const isAviatorCrushLeadComplete = (lead: Partial<AviatorCrushLead>): lead is AviatorCrushLead =>
  AVIATOR_CRUSH_LEAD_FIELD_NAMES.every((fieldName) => {
    const value = lead[fieldName];
    return typeof value === 'string' && isAviatorCrushLeadFieldValid(fieldName, value);
  });
